'use strict';

import React, { Component } from 'react';
import { connect } from 'react-redux'

class Upload extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onChange(event){
    if ( ! event.target.files.length ) {
      return;
    }

    const file = event.target.files[0];

    this.props.onFileUpload(file);
  }

  onClick(event){
	const button = event.target,
	input = button.parentNode.querySelector('#fileUpload');

	if( ! input ) {
		return;
	}
	
	input.click();
  }

  render() {
    return (
      <div className="fileUpload">
        <svg onClick={this.onClick} width="14" height="14" viewBox="0 0 14 14">
          <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M6 4.6v5c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1V2.7C8.2 1.5 7.2.5 6 .5s-2.2 1-2.2 2.2v7.5c0 1.8 1.5 3.3 3.3 3.3s3.3-1.5 3.3-3.3V4.6" />
        </svg>
        <input type="file" id="fileUpload" onChange={this.onChange}/>
      </div>
    );
  }
}


Upload.displayName = 'Upload';
Upload.propTypes = {
  onFileUpload: React.PropTypes.func
};

export default connect()(Upload);



// WEBPACK FOOTER //
// ./src/components/Upload.js